import React from 'react';
import styled from '@emotion/styled';
import { BrandUtil } from 'dw-us-ui';

const PageNotFoundContainer = styled.div`
  margin-top: 20px;
  .heading {
    font-family: ${({ theme }) => theme.fonts.special};
    color: ${({ theme }) => theme.colors.headerRed};
    font-size: 30px;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 16px;
  }
  p {
    margin-bottom: 16px;
  }
`;

const PageNotFound = () => {
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  return (
    <PageNotFoundContainer brandTag={brandTag}>
      <h1 className="heading">Well, this is awkward ...</h1>
      <p>
        The page you were looking for appears to have been moved, deleted or does not exist. You could{' '}
        <a href="javascript:history.back()">go back to where you were</a> or head straight to our{' '}
        <a href="/">home page </a>
        and continue shopping.
      </p>
    </PageNotFoundContainer>
  );
};

export default PageNotFound;
